<template>
  <div id="location">
    <div class="inner">
      <div class="top">
        <div class="top_box">
          <div class="top_title">{{ $t("home_location_title") }}</div>
        </div>
        <div class="top_list">
          <div
            v-for="(item, idx) in topList"
            :key="idx"
            class="top_list_item"
            :class="[
              { active: hoverIndex === idx },
              { first: idx === 0 },
              { last: idx === topList.length - 1 },
              { expanded: hoverIndex === idx },
            ]"
            @mouseenter="hoverIndex = idx"
            @mouseleave="hoverIndex = 0"
          >
            <img :src="item.imgLarge" class="top_list_item_img" />
            <div class="img_mask" v-if="hoverIndex !== idx"></div>
            <div class="img_title" :class="{ bottom: hoverIndex === idx, uk_longtext: country === 'uk' &&  hoverIndex !== idx && idx === 2 }">
              {{ $t(item.title) }}
            </div>
          </div>
        </div>
        <div class="top_item_desc">
          <div class="top_item_desc_title">
            <template v-if="country === 'uk'">
              {{ $t("home_location_available") }}
            </template>
          </div>
          <div class="top_item_desc_content">
            {{ $t("home_location_desc") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCountryByDomain } from "@/common/config";
export default {
  name: "LocationView",
  data() {
    return {
      hoverIndex: 0, //默认第一张大图
      topList: getCountryByDomain(window.location.hostname) === 'uk' ? [
        {
          // imgSmall: require("@/assets/Keeta2/store(small)@2x.png"),
          imgLarge: require("@/assets/Keeta2/Restaurant(large)@2x.png"),
          title: "home_location_restaurant",
        },
        {
          // imgSmall: require("@/assets/Keeta2/Pub(small)@2x.png"),
          imgLarge: require("@/assets/Keeta2/Pub(large)@2x.png"),
          title: "home_location_pub",
        },
        {
          // imgSmall: require("@/assets/Keeta2/Restaurant(small)@2x.png"),
          imgLarge: require("@/assets/Keeta2/Entertainment Venues(large)@2x.png"),
          title: "home_location_venues",
        },
        {
          // imgSmall: require("@/assets/Keeta2/Casinos(small)@2x.png"),
          imgLarge: require("@/assets/Keeta2/Retail(large)@2x.png"),
          title: "home_location_store",
        },
        {
          // imgSmall: require("@/assets/Keeta2/Hotel(small)@2x.png"),
          imgLarge: require("@/assets/Keeta2/Hotel(large)@2x.png"),
          title: "home_location_hotel",
        }
      ] : [
        {
          // imgSmall: require("@/assets/Keeta2/Hotel(small)@2x.png"),
          imgLarge: require("@/assets/Keeta2/hkRestaurant.png"),
          title: "home_location_restaurant",
        }, {
          // imgSmall: require("@/assets/Keeta2/Hotel(small)@2x.png"),
          imgLarge: require("@/assets/Keeta2/hkHotel.png"),
          title: "home_location_hotel",
        },{
          // imgSmall: require("@/assets/Keeta2/Hotel(small)@2x.png"),
          imgLarge: require("@/assets/Keeta2/hkPlay.png"),
          title: "home_location_play",
        }
      ]
    };
  },
  mounted() {
    this.topList.forEach((item) => {
      const imgLarge = new Image();
      imgLarge.src = item.imgLarge;
      const imgSmall = new Image();
      imgSmall.src = item.imgSmall;
    });
  },
  computed: {
    country() {
      return getCountryByDomain(window.location.hostname);
    }
  },
};
</script>
<style scoped lang="scss">
@import "@/styles/_variables.scss";
#location {
  // width: 100%;
  min-width: $min-width;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 0 120px 0;
  background-color: #f7f8f9;
  .inner {
    width: 1200px;
  }

  .top {
    display: flex;
    flex-direction: column;
    .top_box {
      width: 100%;
      min-width: 431px;
      .top_title {
        color: #000;
        font-weight: 900;
        font-size: 1.3rem;
        font-family: $title-font;
      }
    }
    .top_list {
      width: 100%;
      height: 501px;
      display: flex;
      margin-top: 80px;
      .top_list_item {
        position: relative;
        height: 100%;
        flex: 1;
        margin-right: 9.5px;
        overflow: hidden;
        transition: all 0.7s cubic-bezier(0.4, 0, 0.2, 1);
        cursor: pointer;

        &.active {
          flex: 3;
          .top_list_item_img {
            transform: scale(1.05);
            filter: grayscale(0);
          }
          .img_mask {
            opacity: 0;
          }
        }

        .top_list_item_img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: right;
          transform-origin: center right;
        }
        .img_title {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #ffffff;
          font-weight: bold;
          font-size: $font-size-base;
          transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
          z-index: 4;
          text-align: center;
          font-family: $content-font;
          text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7);

          &.bottom {
            top: 85%;
            font-size: $font-size-base;
          }
        }
        .uk_longtext {
          // font-size: $font-size-mini;
        }
        &.first {
          border-top-left-radius: 20px;
          border-bottom-left-radius: 20px;
          .top_list_item_img {
            border-top-left-radius: 20px;
            border-bottom-left-radius: 20px;
          }
          .img_mask {
            border-top-left-radius: 20px;
            border-bottom-left-radius: 20px;
          }
        }

        &.last {
          border-top-right-radius: 20px;
          border-bottom-right-radius: 20px;
          margin-right: 0;
          .top_list_item_img {
            border-top-right-radius: 20px;
            border-bottom-right-radius: 20px;
            object-position: center;
          }
          .img_mask {
            border-top-right-radius: 20px;
            border-bottom-right-radius: 20px;
          }
        }

        .img_mask {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0.2),
            rgba(0, 0, 0, 0.5)
          );
          z-index: 2;
          pointer-events: none;
          transition: opacity 0.5s ease;
        }
      }
    }
    .top_item_desc {
      background-color: #fafafa;
      font-family: $content-font;
      .top_item_desc_title {
        color: #111111;
        font-family: Arial;
        font-weight: 700;
        font-size: $font-size-small;
        line-height: normal;
        text-align: left;
        box-sizing: border-box;
        margin: 40px 0 20px 10px;
      }
      .top_item_desc_content {
        font-weight: 400;
        font-family: Arial;
        font-size: $font-size-mini;
        line-height: 28px;
        text-align: left;
        color: #888888;
        margin: 0 0 0 10px;
      }
    }
  }
}
</style>